import { teApi } from 'yxt-biz-pc/packages/api';

// 获取讲师编辑申请信息
export const getDraftDetail = (draftId) => {
  return teApi.get(`/uc/edit/detail/${draftId}`);
};
